import React, { useEffect, useMemo } from "react";
import { SelectDropdown, TagsInput } from "@cadmakers-ui/core";
import { Tag, useTags } from "..";

type Props = {
  selectedId?: number;
  onSelectedTypeChange: (selectedId: number) => void;
};

const FeedbackBugReportTypePicker: React.FC<Props> = props => {
  const tags = useTags();

  const tagOptions = useMemo(() => {
    if (!tags.loadingState.isLoaded) {
      return [];
    }

    return tags.tags
      .filter(t => t.isBugTypeTag)
      .map(t => ({
        value: t.id,
        label: t.name
      }));
  }, [tags]);

  const selectedOption = useMemo(() => {
    return tagOptions.filter(t => t.value === props.selectedId)[0];
  }, [tagOptions, props.selectedId]);

  const onTagsInputChange = (newValue: any) => {
    props.onSelectedTypeChange(newValue.value);
  };

  return (
    <SelectDropdown options={tagOptions} value={selectedOption} onChange={onTagsInputChange} />
  );
};

export default FeedbackBugReportTypePicker;
